<script setup>
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  label: { type: String, required: true },
  multiple: { type: Boolean, default: true },
  options: { type: Array, default: () => [] },
});
const model = defineModel({
  type: [Array, String, Number],
  required: true,
});
const optionValue = option => option?.id ?? option?.value ?? '';
const optionLabel = option => option?.label ?? option?.name ?? '';
</script>

<template>
  <LaisField :label="label">
    <select
      v-model="model"
      :multiple="multiple"
      class="min-h-10 rounded-lais border border-lais-border bg-white px-3 py-2 text-sm"
    >
      <option
        v-for="option in options"
        :key="optionValue(option)"
        :value="optionValue(option)"
      >
        {{ optionLabel(option) }}
      </option>
    </select>
  </LaisField>
</template>
